module.exports = __webpack_public_path__ + "img/icon_instagram_txt_moins.ea1553a7.png";